module.exports = __webpack_public_path__ + "img/051.b128cc87.png";